module.exports = __webpack_public_path__ + "img/no_data1.aec40258.png";